import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { IPerfil } from "../types/perfil.types";
import { InputDecimalPtBr } from "../../components/InputDecimalPtBr";

// Estilos padronizados para inputs (igual à aba GERAL)
const inputSx = {
  backgroundColor: "#f0f0f0",
  borderRadius: 0,
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiInputBase-input": {
    padding: "20px 14px 8px 14px",
  },
  minHeight: 56,
};

const labelSx = {
  color: "#3C90AD",
  fontWeight: 500,
  fontSize: "0.8rem",
  "&.Mui-focused": {
    color: "#3C90AD",
  },
};

interface TabDadosAdicionaisProps {
  perfil: Partial<IPerfil>;
  onChange: (campo: keyof IPerfil, valor: any) => void;
  figuraUrl?: string;
  onOpenMidias: () => void;
}

// FASE 05 — 2ª validação/PO 2026-07-24:
// (F12) Liga e Tempera saíram desta aba — ficam apenas na aba GERAL (eram duplicados).
// (F5) Campos decimais aceitam vírgula com zero antes (ex.: 0,123) via InputDecimalPtBr.
export const TabDadosAdicionais: React.FC<TabDadosAdicionaisProps> = ({
  perfil,
  onChange,
  figuraUrl,
  onOpenMidias,
}) => {
  return (
    <Grid container spacing={3}>
      {/* Coluna Esquerda - Imagem do Produto */}
      <Grid item xs={12} md={3}>
        {/* Container da Imagem - COM BORDA CINZA */}
        <Box
          sx={{
            border: "1px solid #e0e0e0",
            backgroundColor: "#fff",
            p: 2,
            mb: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: "#333", mb: 2, fontWeight: 500 }}
          >
            Imagem do produto
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 180,
              backgroundColor: "#fff",
            }}
          >
            {figuraUrl ? (
              <img
                src={figuraUrl}
                alt="Imagem do produto"
                style={{ maxWidth: "100%", maxHeight: 180, objectFit: "contain" }}
              />
            ) : (
              <Typography variant="body2" color="text.secondary">
                Nenhuma imagem
              </Typography>
            )}
          </Box>
        </Box>

        {/* Botão FORA do container da imagem */}
        <Button
          variant="contained"
          fullWidth
          onClick={onOpenMidias}
          sx={{
            backgroundColor: "#3C90AD",
            "&:hover": { backgroundColor: "#2d6f87" },
            textTransform: "none",
            py: 1.2,
          }}
        >
          GERENCIAMENTO DE MÍDIAS
        </Button>
      </Grid>

      {/* Coluna Direita - Campos */}
      <Grid item xs={12} md={9}>
        <Box>
          <Grid container spacing={2}>
            {/* Linha 1: WX e JX */}
            <Grid item xs={12} sm={6}>
              <InputDecimalPtBr
                fullWidth
                label="WX"
                value={perfil.wxt}
                onChange={(v) => onChange("wxt", v ?? 0)}
                InputLabelProps={{ sx: labelSx }}
                sx={inputSx}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputDecimalPtBr
                fullWidth
                label="JX"
                value={perfil.jxt}
                onChange={(v) => onChange("jxt", v ?? 0)}
                InputLabelProps={{ sx: labelSx }}
                sx={inputSx}
              />
            </Grid>

            {/* Linha 2: WY e JY */}
            <Grid item xs={12} sm={6}>
              <InputDecimalPtBr
                fullWidth
                label="WY"
                value={perfil.wy}
                onChange={(v) => onChange("wy", v ?? 0)}
                InputLabelProps={{ sx: labelSx }}
                sx={inputSx}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputDecimalPtBr
                fullWidth
                label="JY"
                value={perfil.jy}
                onChange={(v) => onChange("jy", v ?? 0)}
                InputLabelProps={{ sx: labelSx }}
                sx={inputSx}
              />
            </Grid>

            {/* Linha 3: Perímetros */}
            <Grid item xs={12} sm={6}>
              <InputDecimalPtBr
                fullWidth
                label="Perímetro total"
                value={perfil.perimetroTotal}
                onChange={(v) => onChange("perimetroTotal", v ?? 0)}
                InputLabelProps={{ sx: labelSx }}
                sx={inputSx}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputDecimalPtBr
                fullWidth
                label="Perímetro de tratamento"
                value={perfil.perimetroTratamento}
                onChange={(v) => onChange("perimetroTratamento", v ?? 0)}
                InputLabelProps={{ sx: labelSx }}
                sx={inputSx}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};
